<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div style="text-align: center;">
					<h4 style="font-weight: bold; margin-bottom: 10px">{{$store.state.lang.text.my_promotion[$store.state.lang.language]}}</h4>
				</div>
			</div>
			<!-- <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<p style="font-size: 15px; font-weight: bold; margin-bottom: 10px">ការផ្តល់ជូនសម្រាប់សមាជិកថ្មី (សូមជ្រើសរើសដើម្បីស្នើ)</p>
			</div> -->
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<div class="promotion-list-menu">
					<div class="promotion-left">
						<span style="font-weight: bold">ការផ្តល់ជូនបន្ថែម ១០០% នៅពេលដាក់ប្រាក់លើកដំបូង</span>
					</div>
					<div class="promotion-right" style="white-space: nowrap;">
						<span class="green">ស្នើសុំ</span>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<div class="promotion-list-menu">
					<div class="promotion-left">
						<span style="font-weight: bold">ការផ្តល់ជូន $9 នៅពេលបង្កើតគណនីដំបូង</span>
					</div>
					<div class="promotion-right" style="white-space: nowrap;">
						<span class="green">ស្នើសុំ</span>
					</div>
				</div>
			</div>
			<!-- <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="balance">{{$store.state.lang.text.balance[$store.state.lang.language]}}</label>
							<input id="balance" type="text" disabled="disabled" :value="config.moneylify(user.balance)" :placeholder="$store.state.lang.text.balance[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';

	export default {
		components: {

		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			// this.getUser();
			// this.getPayment();
		},
		methods: {
			getUser() {
				this.$http.get(this.config.api + "/user/authed/user/get_balance").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.user = res.body.data
					}
				})
			},
		},
		computed: {
		},
		data() {
			return {
				select: "",
				loaded: true
			}
		}
	}
</script>
<style>
	.promotion-list-menu {
		cursor:pointer; border-radius: 15px;padding: 14px; margin-bottom: 15px;background-color: #20283F;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.promotion-left {
		width: 100%;
	}
	.promotion-right {

	}
	/* @media (max-width: 1264px) {
		.account-list-menu:nth-child(odd) {
			min-width: calc(40% - 15px) !important;
			max-width: calc(40% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	@media (max-width: 944px) {
		.account-list-menu:nth-child(odd) {
			min-width: calc(50% - 15px) !important;
			max-width: calc(50% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	.account-active {
		background-color: #20283F;
	} */

</style>



// WEBPACK FOOTER //
// src/pages/Account/Promotions.vue